import React from 'react';

interface InvoiceAdminNoteProps {
  note: string;
}

export const InvoiceAdminNote: React.FC<InvoiceAdminNoteProps> = ({ note }) => (
  <div className="invoice-details-modal__admin-note">
    <span className="invoice-details-modal__admin-note-label">Note from Admin</span>
    <p>{note}</p>
  </div>
);
